<div *ngIf="currentSetting" style="padding-left:5px;">
	<mat-card-title>
		{{currentSetting.TITLE}}
		<help-text-btn class="align-help-text-btn" [helpTextId]="currentSetting.HELP_TEXT_ID"></help-text-btn>
	</mat-card-title>
	<mat-divider> </mat-divider>
	<br>
	<div class="row" style="position:relative;margin-left:0px;">
		<mat-card appearance="outlined" class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6" style="min-width:450px;">
			<h3 style="padding-left:18px;padding-top:5px;font-size:large;">
				Search Criteria
			</h3>
			<mat-card-content>
				<region-dropdown-two-way [isMultiple]="true" [(selectedRegions)]="chosenRegions" [reset]="resetField"
					[required]="true" #appRegionCode>
				</region-dropdown-two-way>

				<county-dropdown-two-way [isMultiple]="true" [(selectedCounties)]="chosenCounties" [reset]="resetField"
					[required]="false" #appCountyCode [regions]="chosenRegions">
				</county-dropdown-two-way>

				<district-dropdown-two-way [isMultiple]="true" [(selectedSchoolDistricts)]="chosenSchoolDistricts"
					[reset]="resetField" [required]="false" #appDistrictCode [regions]="chosenRegions"
					[counties]="chosenCounties">
				</district-dropdown-two-way>

				<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools" [reset]="resetField"
					#appSchools [regions]="chosenRegions" [counties]="chosenCounties"
					[schoolDistricts]="chosenSchoolDistricts">
				</school-dropdown-two-way>

				<app-school-year [label]="'School Year'" [yearType]="'SchoolYear'"
					(performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0" [yearsForward]="0"
					[yearsBack]="2" [reset]="resetField" [required]="true"
					[startingSchoolYearDate]="startingSchoolYearDate" *ngIf="currentSetting.SCHOOL_YEAR">
				</app-school-year>
				<app-school-year [label]="'Performance Period'" [yearType]="'PerformancePeriod'"
					(performancePeriodEvent)="performancePeriodEvent($event)" [currentYearModifier]="0"
					[yearsForward]="0" [yearsBack]="2" [reset]="resetField" [required]="true"
					[startingSchoolYearDate]="startingSchoolYearDate" *ngIf="currentSetting.PERFORMANCE_PERIOD">
				</app-school-year>
			</mat-card-content>
			<mat-card-actions>
				<span style="padding:5px;padding-bottom:10px;">
					<span style="padding-right:15px;">
						<button mat-raised-button color="primary" mat-button
							[disabled]="!this.checkValid() || isLoading" (click)="search()">
							<mat-icon *ngIf="isLoading">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Search
						</button>
					</span>
					<span style="padding-right:15px;">
						<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
					</span>
					<span>
						<button [disabled]="!(results.length > 0) || isExporting" mat-raised-button
							[matMenuTriggerFor]="menu" class="margin-right-xs">
							<mat-icon *ngIf="isExporting">
								<mat-spinner diameter="18"> </mat-spinner>
							</mat-icon>
							Export
							<mat-icon *ngIf="!isExporting">more_vert</mat-icon>
						</button>
						<mat-menu #menu="matMenu">
							<button mat-menu-item (click)="downloadExcel()">
								<span>
									<i class="fa fa-file"></i>
									Export to Excel</span>
							</button>
						</mat-menu>
					</span>
				</span>
			</mat-card-actions>
		</mat-card>
	</div>

	<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>


	<div *ngIf="results.length > 0" class="margin-top-md" style="width:100%;">

		<mat-tab-group id="data-monitoring-divided-tab-group" animationDuration="0ms" [(selectedIndex)]="selectedIndex">
			<mat-tab [label]="regionLabel">
				<div class="margin-top-sm table-responsive">
					<mat-table [dataSource]="regionDataSource" class="mat-elevation-z1  table-responsive fixed-layout"
						style="width:100%;" matSort>
						<ng-container matColumnDef="CODE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Region Code </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.CODE}} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="NAME">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Region Name </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.NAME}} </mat-cell>
						</ng-container>

						<ng-container matColumnDef="COUNT">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Count </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.COUNT}}
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="regionColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: regionColumns;">
						</mat-row>
					</mat-table>
				</div>
			</mat-tab>
			<mat-tab [label]="countyLabel">
				<mat-table [dataSource]="countyDataSource" class="mat-elevation-z1" matSort>
					<ng-container matColumnDef="CODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> County Code </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.CODE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> County Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.NAME}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="COUNT">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Count </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.COUNT}}
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="countyColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: countyColumns;">
					</mat-row>
				</mat-table>
			</mat-tab>
			<mat-tab [label]="schoolDistrictLabel">
				<mat-table [dataSource]="schoolDistrictDataSource"
					class="mat-elevation-z1 table-responsive fixed-layout" style="width:100%;" matSort>
					<ng-container matColumnDef="CODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School District Code </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.CODE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School District Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.NAME | titlecase}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="COUNT">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Count </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.COUNT}}
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="schoolDistrictColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: schoolDistrictColumns;">
					</mat-row>
				</mat-table>
			</mat-tab>
			<mat-tab [label]="schoolLabel">
				<mat-table [dataSource]="schoolDataSource" class="mat-elevation-z1  table-responsive fixed-layout"
					style="width:100%;" matSort>
					<ng-container matColumnDef="CDSCODE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> CDS Code </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.CDSCODE}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.NAME | titlecase}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="COUNT">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Count </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.COUNT}}
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="schoolColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: schoolColumns;">
					</mat-row>
				</mat-table>
			</mat-tab>

			<mat-tab [label]="searchResultLabel">

				<div class="adjstgWidth">
					<!-- keep this below 100% otherwise redundant horizontal scroll will appear -->
					<h2>
						Search Results - {{'(' + currentSchoolYear + ')'}} - ({{(searchResultDataSource ?
						(searchResultDataSource.filteredData.length < results.length ?
							searchResultDataSource.filteredData.length + '/' : '' ) : '' ) + results.length}} Children)
							</h2>
							<hr />

							<div class="row">
								<mat-form-field>
									<mat-label>
										Filter
									</mat-label>
									<input matInput id="filter" name="filter" type="string"
										[(ngModel)]="searchResultFilter"
										(ngModelChangeDebounced)="setFilter(searchResultDataSource, searchResultFilter)" />
								</mat-form-field>
							</div>

							<div class="margin-top-sm"><!-- table-responsive-->
								<mat-table #searchResults [dataSource]="searchResultDataSource"
									class="mat-elevation-z1 table-responsive fixed-layout" matSort>

									<ng-container matColumnDef="SCHOOL.REGIONS.CODE">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;">
											Region </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:70px;">
											{{element.SCHOOL.REGIONS.CODE}} </mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;">
											School Year </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:90px;">
											{{element.SCHOOL_ENROLLMENT_DETAILS[0].SCHOOL_YEAR}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL.SCHOOL_DISTRICT.DISTRICTS">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;">
											District </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:150px;">
											{{element.SCHOOL.SCHOOL_DISTRICT.DISTRICTS |
											titlecase}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL.NAME">
										<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.SCHOOL.NAME | titlecase}}
										</mat-cell>
									</ng-container>

									<!--
								<ng-container matColumnDef="SCHOOL.cdscODE">
									<mat-header-cell *matHeaderCellDef mat-sort-header> School CDS Code
									</mat-header-cell>
									<mat-cell *matCellDef="let element"> {{element.SCHOOL.cdscODE}} </mat-cell>
								</ng-container>
								-->
									<ng-container matColumnDef="MSD_NUMBER">
										<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number
										</mat-header-cell>
										<mat-cell *matCellDef="let element">
											<edit-child-modal-btn [studentId]="element.ID" [type]="'string'"
												[displayText]="element.MSD_NUMBER">
											</edit-child-modal-btn>
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SSID">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:120px;">
											SSID </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:120px;">
											{{element.SSID}}</mat-cell>
									</ng-container>

									<ng-container matColumnDef="PERSON.LAST_NAME">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:120px;">
											Name </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:120px;">
											{{element.PERSON.LAST_NAME |
											titlecase}}{{(element.SECOND_LAST_NAME
											? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}}
											{{element.PERSON.FIRST_NAME |
											titlecase}}
											{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
									</ng-container>

									<ng-container matColumnDef="DOB">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;"> DOB
										</mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:100px;"> {{element.DOB |
											simpleDate}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;">
											Grade </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:70px;">
											{{(element.SCHOOL_ENROLLMENT_DETAILS ?
											element.SCHOOL_ENROLLMENT_DETAILS[0].GRADE : '')}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;">
											Enroll Type </mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:70px;">
											{{element.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE}} </mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
										<mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;">
											Enrollment Date
										</mat-header-cell>
										<mat-cell *matCellDef="let element" style="min-width:100px;">
											{{(element.SCHOOL_ENROLLMENT_DETAILS ?
											element.SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE : '')
											| simpleDate}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date
										</mat-header-cell>
										<mat-cell *matCellDef="let element"> {{(element.SCHOOL_ENROLLMENT_DETAILS ?
											element.SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE : '')
											| simpleDate}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
										<mat-cell *matCellDef="let element"> {{(element.STUDENT_ELIGIBILITIES ?
											element.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE : '')
											| simpleDate}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="STUDENT_TERMINATION_STATUSES[0].STATUS_DATE">
										<mat-header-cell *matHeaderCellDef mat-sort-header> Termination Date
										</mat-header-cell>
										<mat-cell *matCellDef="let element"> {{(element.STUDENT_TERMINATION_STATUSES ?
											element.STUDENT_TERMINATION_STATUSES[0].STATUS_DATE : '')
											| simpleDate}}
										</mat-cell>
									</ng-container>

									<ng-container matColumnDef="COE_NUMBER">
										<mat-header-cell *matHeaderCellDef mat-sort-header> COE Number
										</mat-header-cell>
										<mat-cell *matCellDef="let element"> {{element.COE_NUMBER}}
										</mat-cell>
									</ng-container>

									<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
									<mat-row *matRowDef="let row; columns: displayedColumns;"
										[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
										[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
										[matTooltipPosition]="'above'"
										[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
										[matTooltipClass]="'terminatedTooltip'">
									</mat-row>
								</mat-table>
								<mat-paginator #paginators [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
									aria-label="Select page of periodic elements">
								</mat-paginator>
							</div>
				</div>
			</mat-tab>
		</mat-tab-group>
	</div>
</div>